import React, { useEffect, useMemo, useState } from 'react';
import {
  buildLucideSvgElement,
  localLucideIcons,
  resolveIconRegistry
} from '../utils/lucideHelpers.js';

const Icon = ({ name, size = 16, strokeWidth = 2, className = '' }) => {
  const [renderKey, setRenderKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    if (typeof window === 'undefined') {
      return undefined;
    }
    const hasIcons = () => Boolean(window.lucide?.icons || localLucideIcons);
    if (hasIcons()) {
      setRenderKey((prev) => prev + 1);
      return undefined;
    }
    const interval = window.setInterval(() => {
      if (hasIcons() && !cancelled) {
        setRenderKey((prev) => prev + 1);
        window.clearInterval(interval);
      }
    }, 120);
    return () => {
      cancelled = true;
      window.clearInterval(interval);
    };
  }, [name]);

  const svg = useMemo(() => {
    const registry = resolveIconRegistry(typeof window !== 'undefined' ? window.lucide : null);
    const svgElement = buildLucideSvgElement(registry, name, {
      width: size,
      height: size,
      strokeWidth,
      className
    });
    if (!svgElement) {
      return null;
    }
    try {
      return svgElement.outerHTML;
    } catch (error) {
      console.warn('No se pudo renderizar el ícono', name, error);
      return null;
    }
  }, [name, size, strokeWidth, renderKey]);

  if (!svg) {
    return <span className={className} aria-hidden="true" />;
  }

  const classes = ['lucide-icon', className].filter(Boolean).join(' ');
  return (
    <span
      className={classes}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};

export default Icon;
